import React from 'react';
import CustomDialog from 'shared/CustomDialog';
import { IContract } from 'pages/ContractManagment/ContractManagement.models';
import RequestAcceptedModalContent from 'pages/ContractManagment/ContractManagementList/RequestsActions/RequestAcceptedModal/RequestAcceptedModalContent';

interface IRequestAcceptedModalProps {
  isOpen: boolean;
  onCloseModal: ()=> void;
  selectedContracts: IContract[];
}

const RequestAcceptedModal: React.FC<IRequestAcceptedModalProps> = ({
  isOpen,
  onCloseModal,
  selectedContracts,
}) => (
  <CustomDialog
    isModalOpen={isOpen}
    onCloseModal={onCloseModal}
    renderChildren={(onClose) => (
      <RequestAcceptedModalContent
        onCloseModal={onClose}
        selectedContracts={selectedContracts}
      />
    )}
  />
);

export default RequestAcceptedModal;
